/**
 * 배우 디폴트 아이콘 (사람 실루엣, #E9E9EC 배경)
 * 제작사 디폴트 아이콘 (건물, #E9E9EC 배경)
 */

const TALENT_SQUARE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="240" height="300" viewBox="0 0 240 300"><rect width="240" height="300" rx="0" fill="%23E9E9EC"/><circle cx="120" cy="108" r="52" fill="%23A9A9B2"/><path d="M0 300c0-66.3 53.7-120 120-120s120 53.7 120 120" fill="%23A9A9B2"/></svg>`;

export const TALENT_PLACEHOLDER = '/assets/images/user.svg';
export const TALENT_PLACEHOLDER_SQUARE = `data:image/svg+xml;utf8,${TALENT_SQUARE_SVG}`;
export const PRODUCER_PLACEHOLDER = '/assets/images/studio.svg';

/** 인물이 아닌 일반 이미지(스틸컷·갤러리·로고)용 기본 아이콘 */
const IMAGE_SVG = `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"><rect x="3" y="4.5" width="18" height="15" rx="2.5" stroke="%23A2A2A2" stroke-width="2"/><circle cx="8.75" cy="9.75" r="1.5" fill="%23A2A2A2"/><path d="M3.5 16.5 8 12.5l3.5 3 4-4.5 5 5.5" stroke="%23A2A2A2" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>`;
export const IMAGE_PLACEHOLDER = `data:image/svg+xml;utf8,${IMAGE_SVG}`;
const TALENT_PROFILE_IMAGE_REMOVED_KEY = 'talent-profile-image-removed';

/**
 * role에 따라 디폴트 placeholder URL 반환
 * @param {'TALENT'|'PRODUCER'|'profile'|'company'} type
 */
export function getDefaultProfileImage(type) {
  if (type === 'PRODUCER' || type === 'company') return PRODUCER_PLACEHOLDER;
  return TALENT_PLACEHOLDER;
}

/**
 * 기존 호환성 유지 — 내부적으로 role 기반 placeholder 반환
 */
export function buildProfilePlaceholderDataUrl(name = '', type = 'profile') {
  return getDefaultProfileImage(type);
}

export function markTalentProfileImageRemoved(removed) {
  try {
    localStorage.setItem(TALENT_PROFILE_IMAGE_REMOVED_KEY, removed ? 'true' : 'false');
  } catch {}
}

export function isTalentProfileImageRemoved() {
  try {
    return localStorage.getItem(TALENT_PROFILE_IMAGE_REMOVED_KEY) === 'true';
  } catch {
    return false;
  }
}

/**
 * API 응답에서 실제 프로필 이미지 URL을 결정
 * - medias 배열이 있으면 PROFILE_CLOSE_UP 타입만 인정
 * - medias 없으면 profileImageUrl 신뢰
 * - isTalentProfileImageRemoved() 가 true면 항상 null
 * @param {{ profileImageUrl?: string, medias?: Array }} profile
 * @returns {string|null}
 */
export function resolveProfileImageUrl(profile) {
  if (!profile) return null;
  if (isTalentProfileImageRemoved()) return null;
  const medias = profile.medias || [];
  if (medias.length > 0) {
    return medias.find(m => m.photoType === 'PROFILE_CLOSE_UP' && m.url)?.url ?? null;
  }
  return profile.profileImageUrl ?? null;
}
